import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, Paper, Stack, Typography, Tooltip, alpha } from '@mui/material';
import React from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const formatCount = (value) => {
  if (value === null || value === undefined) return '';

  const str = value.toString();

  // show dots if very large number
  //   if (str.length > 6) {
  //     return str.slice(0, 6) + '...';
  //   }

  return value.toLocaleString();
};

export const getLightBgColor = (hexColor, colorIntensity = 0.06) => {
  if (!hexColor) return 'rgba(0,0,0,0.08)';

  const hex = hexColor.replace('#', '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${colorIntensity})`; //smaller value gets smaller color intensity increase then color gets darker
};

const mixWithBlack = (hexColor, amount = 0.3) => {
  const hex = hexColor.replace('#', '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const newR = Math.round(r * (1 - amount));
  const newG = Math.round(g * (1 - amount));
  const newB = Math.round(b * (1 - amount));

  return `rgb(${newR}, ${newG}, ${newB})`;
};

const InduvidualCard = ({ item, color }) => {
  const isPositive = item.trend > 0;
  const mainColor = color || '#1976d2';
  const lightBg = getLightBgColor(mainColor);

  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        borderRadius: 3,
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        backgroundColor: lightBg,
        '&:hover': {
          //   transform: 'translateY(-4px)',
          boxShadow: 6,
        },
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: lightBg,
          }}
        >
          <Icon icon={item.icon || 'mdi:account-multiple-tick'} width="22" height="22" color={mainColor} />
        </Box>

        <Tooltip title={item.name}>
          <Typography
            variant="body1"
            fontWeight={600}
            noWrap
            sx={
              {
                //   maxWidth: 140,
                //   color:mixWithBlack(mainColor,0.3)
              }
            }
          >
            {item.name}
          </Typography>
        </Tooltip>
      </Stack>

      {/* Count + Trend */}
      <Stack direction="row" alignItems="center" spacing={1} mt={1} ml={0.6}>
        <Tooltip title={item?.value}>
          <Typography
            fontWeight={700}
            noWrap
            sx={{
              maxWidth: 140,
              fontSize: {
                xs: '1.5rem', // mobile
                md: '1.25rem', // desktop
              },
            }}
          >
            {formatCount(item?.value)}
          </Typography>
        </Tooltip>
      </Stack>

      {/* Sub text */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" color="text.secondary" mt={0.5} display="block" ml={0.5}>
          {item.subDetails}
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          sx={{
            background: isPositive ? '#E8F5E9' : '#FFEBEE',
            px: 1,
            py: 0.3,
            borderRadius: 2,
          }}
        >
          {isPositive ? (
            <TrendingUpIcon
              sx={{
                fontSize: 16,
                color: '#2e7d32',
              }}
            />
          ) : (
            <TrendingDownIcon
              sx={{
                fontSize: 16,
                color: '#dc004e',
              }}
            />
          )}

          <Typography variant="caption" fontWeight={600} color={isPositive ? '#2e7d32' : '#dc004e'}>
            {item.trend}%
          </Typography>
        </Stack>
      </Box>
    </Paper>
  );
};

export default InduvidualCard;
